import SettingFrame from "../../../../../components/@settings/SettingFrame"
import ListLogs from "../../../../../components/@schedulers/logs/ListLogs";

import { routeTypes } from "../../../../../hooks/useSystemRoutes";

export default function LogsPage() {

    let routeType = routeTypes.admin

    return (
        <SettingFrame
            routeType={routeType}
        >
            <ListLogs 
                routeType={routeType}
            />
        </SettingFrame>
    )
}       